/*
Copyright (c) 2022 COUNTRYSIDE STOVE & CHIMNEY, INC. - ALL RIGHTS RESERVED

UNAUTHORIZED COPYING, MODIFICATION, OR DISTRIBUTION OF THIS SOFTWARE AND ASSOCIATED DOCUMENTATION FILES ("THE SOFTWARE"),
IN ANY MEDIUM IS STRICTLY PROHIBITED
PROPRIETARY AND CONFIDENTIAL
WRITTEN BY BRANDON SULLIVAN <info@empiredistributing.net>, March 2022
*/

import React, { useState } from 'react'
import { Image,
Text,
TouchableOpacity,
View,
SafeAreaView,
Alert} from 'react-native';
import { Input, Icon } from 'react-native-elements';
import styles from './styles';
import {
getAuth,
sendPasswordResetEmail } from '../../firebase/config';
import * as Linking from 'expo-linking';
import {  KeyboardAwareScrollViewWithDismiss } from '../../components';

export default function ForgotPasswordScreen({navigation}) {
    const [email, setEmail] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const auth = getAuth();

    const onFooterLinkPress = () => {
        navigation.navigate('Login')
    }

    const onSendEmailPress = (email) => {
    setErrorMessage(null);
    if (!email) {alert("Enter a valid email address"); return;};
    sendPasswordResetEmail(auth, email).then(() => {
    Alert.alert(
                  "Email Sent!",
                  "Password Reset Email Successfully Sent To: " + email,
                  [
                    {
                      text: "Open Email",
                      onPress: () => Linking.openURL('message://'),
                      style: "submit",
                    },

                    {
                            text: "Cancel",
                            style: "cancel",
                          },
                  ],
                  {
                    cancelable: true,
                  }
                )
    navigation.navigate('Login')})
    .catch((err) => {
    switch (err.code) {
    case 'auth/invalid-email':
    setErrorMessage('Invalid Email Address');
    break;
    case 'auth/user-not-found':
    setErrorMessage('Email Address Not Found');
    break;
    }
    console.error("Error with password reset");
    });
    }

    return (
        <SafeAreaView style={styles.container}>
        <KeyboardAwareScrollViewWithDismiss>
        <Image
        style={styles.logo}
        source={require('../../../assets/empireLogoTransparent.png')}
        />

        <Image
         style={styles.welcomeImage}
         source={require('../../../assets/ImageSlider001.jpeg')}
         />
              <View style={styles.inputContainer}>
              <Text style={styles.appMessage}>Enter Email Address</Text>
                  <Input
                   inputStyle={styles.inputStyle}
                   inputContainerStyle={styles.inputContainerStyle}
                   containerStyle={styles.actionInput}
                   leftIcon={{name: 'mail', color: 'black'}}
                   placeholder="Email Address"
                   errorMessage={errorMessage}
                   onChangeText={(text) => {setEmail(text)}}
                   value={email}
                   autoCapitalize="none"
                   textContentType={'emailAddress'}
                   autoComplete={'email'}
                  />
              <TouchableOpacity
              style={styles.button}
              onPress={() => onSendEmailPress(email)}>
              <Text style={styles.buttonTitle}>Send Email</Text>
              </TouchableOpacity>
              <View style={styles.footerView}>
              <Text style={styles.footerText}>Return To Login? <Text onPress={onFooterLinkPress} style={styles.footerLink}>Login</Text></Text>
              </View>
              </View>
             </KeyboardAwareScrollViewWithDismiss>
        </SafeAreaView>
    )
}
